<button
	type="button"
	itButton="link"
	(click)="updateNotifications(); notificationsModal.toggle()"
>
	<span>
		<it-icon
			name="horn"
			[title]="'iterlex.notifications' | translate"
		></it-icon
	></span>
	<span
		[itBadge]="unreadNotificationCount() > 0 ? 'primary' : 'secondary'"
		rounded="true"
		class="align-top"
		>{{ unreadNotificationCount() }}</span
	>
</button>

<it-modal #notificationsModal>
	<ng-container modalTitle>{{
		"iterlex.notifications" | translate
	}}</ng-container>
	<it-checkbox
		[label]="'iterlex.show-archived-notifications' | translate"
		toggle="true"
		inline="true"
		(click)="
			showArchivedNotifications = !showArchivedNotifications;
			updateNotifications()
		"
	></it-checkbox>
	@if (notifications.length === 0) {
		<p>{{ "iterlex.notifications-none" | translate }}</p>
	} @else {
		<it-list>
			@for (notification of notifications; track notification.id) {
				<it-list-item iconLeft="true">
					<div>
						<h4
							class="text m-0"
							[class]="notification.read ? 'fw-normal' : ''"
						>
							{{ notification.title }}
						</h4>
						<p class="small m-0">{{ notification.message }}</p>
					</div>
					<ng-container multiple>
						<span class="metadata" style="overflow-wrap: normal">{{
							notification.date | date: "d/M/yyyy HH:mm"
						}}</span>
						@if (!notification.read) {
							<button
								type="button"
								itButton="link"
								(click)="markNotificationAsRead(notification)"
							>
								<it-icon
									name="check-circle"
									[title]="'iterlex.mark-as-read' | translate"
								></it-icon>
							</button>
						}
						@if (!notification.archived) {
							<button
								type="button"
								itButton="link"
								(click)="
									markNotificationAsArchived(notification)
								"
							>
								<it-icon
									name="box"
									[title]="'iterlex.archive' | translate"
								></it-icon>
							</button>
						}
					</ng-container>
				</it-list-item>
			}
		</it-list>
	}
</it-modal>
